import CacheableDataObject from './CacheableDataObject';
import moment from 'moment';

export default class GroceryListItem extends CacheableDataObject {
	beforeConstruct() {
		this.name = '';
		this.defaultName = '';
		this.checked_off = false;
		/**
		 * The meal ideas this item is on the list for, one per idea's ingredient:
		 * [{ meal_idea_id, meal_idea_ingredient_id, quantity, notes }]. Empty for an item typed in.
		 */
		this.meal_ideas = [];
		/** Its item's tags, alphabetically. */
		this.tags = [];
		/** On the active list only: the last day something of this name was checked off, or null. */
		this.last_bought = null;
		/**
		 * On the active list only: checked off in the last day and moved to a bought list, but still shown
		 * here, crossed out in its place. The server sends it on every active list item.
		 */
		this.struck = false;
		this.instanceNumber = --GroceryListItem.instanceCount;
	}

	idValue() {
		return this.id || this.instanceNumber;
	}

	hasChanges() {
		return this.name !== this.defaultName;
	}

	getStateString() {
		return `${this.name}${this.checked_off}`;
	}
}

GroceryListItem.prototype.dataLocationParsers = {
	name: (item, data) => {
		if(data.id) {
			item.defaultName = data.name;
		}
		item.name = data.name;
	},
	last_bought: (item, data) => {
		item.last_bought = data.last_bought ? moment(data.last_bought, 'YYYY-MM-DD') : null;
	},
	checked_off: (item, data) => {
		if(data.checked_off) {
			if(moment.isMoment(data.checked_off)) {
				item.checked_off = data.checked_off.clone();
			} else {
				item.checked_off = moment.unix(data.checked_off);
			}
		} else {
			item.checked_off = null;
		}
	}

};
GroceryListItem.instanceCount = 0;